<template>
  <nav class="layout-footer footer course-db-footer bg-footer-theme sm_back_btn">
    <div class="container-fluid d-flex flex-wrap justify-content-between">

      <div class="back_btn">
        <b-link :to="{ name: 'courses' }" class="footer-link">
          <span class="ic-arrow-left2"></span>
          <span class="btn_txt">back</span>
        </b-link>
      </div>

      <div class="footer_links_with_back_btn">
        <template v-if="entityUuid">
          <template v-if="isReportTabActive">
            <b-link class="footer-link active">Report</b-link>
            <b-link :to="{ name: (isTransitionPage) ? 'entityResult' : 'entityDetail', params: {uuid: uuid, entityType: 'LearningContent', entityUuid: entityUuid} }" class="footer-link">Learn</b-link>
          </template>
          <template v-else>
            <b-link :to="{ name: 'courseDashboard', params: {uuid: uuid} }" class="footer-link">Home</b-link>
            <b-link :to="{ name: 'courseTOC', params: { uuid: uuid, entityUuid: entityUuid} }" class="footer-link">Content</b-link>
            <template v-if="isTransitionPage">
              <b-link class="footer-link active">Learn</b-link>
            </template>
            <template v-else>
              <b-link :to="{ name: 'entityDetail', params: {uuid: uuid, entityType: 'LearningContent', entityUuid: entityUuid} }" class="footer-link">Learn</b-link>
            </template>
          </template>
        </template>
        <template v-else>
          <b-link :to="{ name: 'courseDashboard', params: {uuid: uuid} }" class="footer-link" :style="{width: (isCourseFinished) ? '100%' : ''}">Home</b-link>
          <template v-if="!isCourseFinished">
            <b-link class="footer-link">Learn</b-link>
          </template>
        </template>
      </div>

    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'courseFooterNavbar',
  props: ['uuid', 'entityUuid', 'isTransitionPage', 'isCourseFinished'],

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    isReportTabActive () {
      return (this.$route.name === 'assessmentReport')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/CourseFooterNavbar.vue